import React from 'react';
import PropTypes from 'prop-types';
import BreadCrumbsV2 from '../../molecules/BreadCrumbsV2/BreadCrumbsV2';
import './BreadcrumbsBar.scss';

const BreadcrumbsBar = ({ location, stateUrl }) => {
	return (
		<div className="breadcrumbs-bar">
			<BreadCrumbsV2
				location={location}
				stateUrl={stateUrl}
				tertiary
			/>
		</div>
	);
};

BreadcrumbsBar.propTypes = {
	location: PropTypes.shape({
		state: PropTypes.string.isRequired,
		fullState: PropTypes.string.isRequired,
	}).isRequired,
	stateUrl: PropTypes.string.isRequired,
};

export default BreadcrumbsBar;
